<div class="notification classic success">
  <div class="notif-content">
    <div class="notif-title">{{ title }}</div>
    <div class="notif-message">{{ message }}</div>
  </div>
</div>
